module.exports = __webpack_public_path__ + "img/03.28a56cb4.svg";